module.exports = __webpack_public_path__ + "img/united_kingdom_flag.9669dd46.svg";